export default __webpack_public_path__ + "static/media/Avatar-16-noback.88460b08.png";